import React from "react";
import { PenLine } from "lucide-react";
import { Page, BackLink } from "./ui";

export default function Blogs() {
  return (
    <Page className="gap-8">
      <BackLink />

      <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
        <span className="flex h-12 w-12 items-center justify-center rounded-full border border-black/10 bg-black/[0.03] text-neutral-600 dark:border-white/10 dark:bg-white/[0.03] dark:text-neutral-400">
          <PenLine size={20} aria-hidden="true" />
        </span>
        <div className="space-y-1">
          <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">
            Cooking at the moment
          </h1>
          <p className="text-sm text-neutral-500">
            Writing is in progress, check back soon.
          </p>
        </div>
      </div>
    </Page>
  );
}
